const logInternal =
  process.env.NODE_ENV === "production"
    ? () => undefined
    : (text, payload) => {
        console.info(`%c${text}`, "color: chocolate");

        if (payload !== undefined) {
          console.info(payload);
        }
      };

const filter = {
  // type: "only-file",
  // value: "OnboardingBreadcrumbs.jsx",
};

function logWrapper(file, block, comment, payload) {
  logInternal(`${file}:${block}:${comment}`, payload);
}

export function log(file, block, comment, payload) {
  if (filter.type === "only-file" && file !== filter.value) return;

  logWrapper(file, block, comment, payload);
}
